<template>
    <div class="fondo">
      
<transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <slot name="body">
          
              <img src="../assets/logo.png" class="logo-edad" alt="">
              
              <div class="mayor" v-if="!edad">
<!-- <h1 class="titulo-edad">SOY MAYOR DE 18 A&Ntilde;OS</h1> -->
              <img src="../assets/mayor.svg" style="margin:30px auto; width:80%; display:block" alt="">

               <!-- <vue-slider ref="edad" v-bind="demo6" style="width:60%; margin:60px auto" @drag-end="chkEdad" :value.sync="value"></vue-slider> -->
               <div style="text-align: center;">
               <a   @click="chkEdad" class="btn-edad">SI</a>
               <a   @click="edad = true" class="btn-edad">NO</a>
               </div>
               
                               <p class="msj-edad">Para entrar en nuestro sitio web, usted debe tener la edad legal para beber alcohol. </p>

              </div>
              <div class="menor"  v-if="edad">
                <h1 class="titulo-edad">ACCESO DENEGADO</h1>
                <p class="msj-edad">Para entrar en nuestro sitio web, usted debe tener la edad legal para beber alcohol. </p>

              </div>
            </slot>
          </div>
   

        </div>
      </div>
    </div>
  </transition>
    </div>
</template>

<script>
// import vueSlider from 'vue-slider-component';

export default {
         components: {
            // vueSlider
        },
        data() {
            return {
              edad:false,
                show: true,
                value: 5,
                demo6: {
                value: [0, 200],
                width: '100%',
                height: 8,
                dotSize: 40,
                min: 5,
                max: 110,
                disabled: false,
                show: true,
                tooltip: 'always',
                tooltipDir: ['bottom', 'top'],
                piecewise: false,
                style: {
                  marginBottom: '30px'
                },
                bgStyle: {
                  backgroundColor: '#fff',
                  boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
                },
                sliderStyle: [{
                  backgroundColor: '#8F0028'
                }, {
                  backgroundColor: '#8F0028'
                }],
                tooltipStyle: [{
                  backgroundColor: '#8F0028',
                  borderColor: '#8F0028'
                }, {
                  backgroundColor: '#8F0028',
                  borderColor: '#8F0028'
                }],
                processStyle: {
                  backgroundImage: '-webkit-linear-gradient(left, #8F0028, #8F0028)'
                }
              },

               
            }
        },
        created(){
          //  let ret = window.localStorage.getItem('edadTermidor')
          //  if(ret){
          //    this.chkEdad()
          //  }
        },
        methods: {
          chkEdad() {
            this.$emit('close')
            // let edad = this.$refs.edad.getValue()
             window.localStorage.setItem('edadTermidor', 18)
//             console.log(edad)
//             if(edad >= 18){
//  this.$emit('close')
//               // this.edad = false

//             }else{
//               this.edad = true
//             }
           
          }
        },
}
    
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  
}
</style>

<style scoped>
.fondo{
  background-attachment: fixed;
  background: url('../assets/bg-int.jpg') no-repeat center center;
  height: 100vh;
  background-size: cover;

}
.btn-edad:hover{
  color:#FFF;
  background: #8F0028;
  /* font-size:20px; */
  transform:scale(1.05)
}
.btn-edad{
  display: inline-block;
  width:30%;
  margin:0 5px;

  text-align:center;
  text-transform: uppercase;
  text-decoration: none;
   font-family: 'Abel', sans-serif;
  color:#8F0028;
  border:2px solid #8F0028;
  font-size:20px;
  padding:20px;
  cursor: pointer;
  transition: all 0.2s;
}
.logo-edad{
  width: 70%;
  display: block;
  margin:0 auto;
}
.titulo-edad{
  text-align:center;
  font-family: 'Abel', sans-serif;
  color:#8F0028;
   text-transform: uppercase;
}
.msj-edad{
   font-family: 'Abel', sans-serif;
  color:#8F0028;
  text-align: center;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  
  
}

.modal-container {
  width: 30%;
  min-width: 300px;
  margin: 0px auto;
  padding: 40px;
  background-color: rgba(255,255,255, .6);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow: hidden;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}



</style>